import { ClientInferResponseBody } from "@ts-rest/core";

import { api, contract } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";
import { IndustrialProcessType } from "shared";

export type PredictedDefaultProcessStepDto = ClientInferResponseBody<
  typeof contract.defaultProcessSteps.getPredicted,
  200
>["predictedDefaultProcessStep"];

export const getPredictedDefaultProcessStep = async ({
  industrialProcess,
  description,
}: {
  industrialProcess: IndustrialProcessType;
  description?: string | null;
}): Promise<PredictedDefaultProcessStepDto> => {
  const response = await api.defaultProcessSteps.getPredicted.query({
    query: { industrialProcess, description: description ?? undefined },
  });

  if (response.status === 200) {
    return response.body.predictedDefaultProcessStep;
  }

  throw new ApiError(
    "Failed to fetch predicted default process step",
    response.status,
    response.body,
  );
};
